import {
  BadRequestResponseError,
  RatesNotFoundResponseError,
} from '@b-stock/fe-core/bstock-next/mutations'
import {
  ddLogger,
  AnalyticsEntityType,
  AnalyticsSource,
} from '@b-stock/fe-core/bstock-react'

import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

export const useOnQuoteError = () => {
  const { errorViewed } = useAnalytics()

  const onQuoteError = (error: unknown) => {
    if (
      error instanceof RatesNotFoundResponseError ||
      error instanceof BadRequestResponseError
    ) {
      errorViewed({
        screenName: 'quote_error',
        source: AnalyticsSource.HOME_PORTAL,
        intention: 'buyer',
        entityType: AnalyticsEntityType.BUYER,
        errorType: 'technical',
        errorMessage: 'quote error',
        errorMessages: error.reasons.join(','),
      })
      ddLogger.info(
        'Anticipated quote generation error',
        { reasons: error.reasons },
        error
      )
    } else {
      errorViewed({
        screenName: 'quote_error',
        source: AnalyticsSource.HOME_PORTAL,
        intention: 'buyer',
        entityType: AnalyticsEntityType.BUYER,
        errorType: 'technical',
        errorMessage: 'Unexpected Error',
      })
      if (error instanceof Error) {
        ddLogger.error('Unxpected quote generation error', undefined, error)
      } else {
        ddLogger.error('Unxpected quote generation error', {
          thrownValue: error,
        })
      }
    }
  }
  return onQuoteError
}
